import {FormControl} from "react-bootstrap";
import React from "react";

function EditableText(
  props: {
    value: string | number,
    placeholder: string,
    maxLength?: number,
    ariaLabel: string,
    onChange: any,
    isEditable: boolean
    isEditing: any,
    type?: string,
    step?: number
    setIsEditing: (value: boolean) => void
  }) {
  const {value, placeholder, maxLength, ariaLabel, onChange, isEditable, isEditing, type, setIsEditing, step} = props;

  function edit() {
    if (isEditable) { // this prevents non-admin from being able to edit
      setIsEditing(true);
    }
  }

  return (
    <>
      <div className="row">
        <div className="col">
          <FormControl
            type={type || "text"}
            value={value}
            maxLength={maxLength}
            onChange={onChange}
            placeholder={placeholder}
            aria-label={ariaLabel}
            readOnly={!isEditing}
            step={step}
            onClick={() => {
              if (isEditable && !isEditing) {
                setIsEditing(true);
              }
            }}
          />
        </div>
      </div>
    </>
  );
}

function EditableTextArea(
  props: {
    value: string,
    placeholder: string,
    maxLength: number,
    rows: number,
    ariaLabel: string,
    onChange: any,
    isEditable: boolean
    isEditing: any,
    setIsEditing: (value: boolean) => void
  }) {
  const {
    value,
    placeholder,
    maxLength,
    rows,
    ariaLabel,
    onChange,
    isEditable,
    isEditing,
    setIsEditing,
  } = props;

  function edit() {
    if (isEditable) { // this prevents non-admin from being able to edit
      setIsEditing(true);
    }
  }

  return (
    <>
      <div className="row">
        <div className="col">
          <FormControl
            type="text"
            value={value}
            maxLength={maxLength}
            onChange={onChange}
            placeholder={placeholder}
            aria-label={ariaLabel}
            as="textarea"
            rows={rows}
            readOnly={!isEditing}
            onClick={() => {
              if (isEditable && !isEditing) {
                setIsEditing(true);
              }
            }}
          />
        </div>
      </div>
    </>
  );
}

export {EditableText, EditableTextArea};
